import { Autocomplete, SxProps, TextField, Theme } from "@mui/material";
import { useContext } from "react";
import { LayoutsConfig, MainContext } from "../context/MainContextProvider";
import { useClientClusterUsinaFilterContext } from "../context/ClientClusterUsinaFilterContextProvider";

export type SelectClientFilterMenuProps = {
    textFieldSx?: SxProps<Theme>
};

export default function SelectClientFilterMenu(props: SelectClientFilterMenuProps) {
    const { textFieldSx } = props;

    const { availableClients, selectedClientFilter, setSelectedClientFilter } =
        useClientClusterUsinaFilterContext();
    const { isMobile, layout } = useContext(MainContext);

    const clientsIds = availableClients?.map((client) => client.id);

    return (
        <Autocomplete
            size="small"
            className="px-2"
            value={selectedClientFilter?.id || ""}
            onChange={(_: any, newValue: string | null | undefined) => {
                const currentClient = availableClients?.find((client) => client.id === newValue);
                setSelectedClientFilter(
                    { id: currentClient?.id || "", name: currentClient?.name || "" }
                );
            }}
            id="plant-select"
            options={clientsIds ?? []}
            getOptionLabel={(option) => {
                return (
                    availableClients?.find((client) => client.id === option)?.name ||
                    ""
                );
            }}
            sx={{ width: isMobile ? "100%" : 200 }}
            renderInput={(params) => <TextField
                sx={{
                    '& .MuiInputBase-input': {
                        color: layout == LayoutsConfig.LayoutTwo ? "#FFF" : undefined,
                    },
                    '& .MuiInputLabel-root': {
                        color: layout == LayoutsConfig.LayoutTwo ? "#8F969E" : undefined,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                        color: layout == LayoutsConfig.LayoutTwo ? '#E9E9E9' : undefined,
                    },
                    ...textFieldSx
                }}
                {...params} label="Client" />}
        />
    );
}
